import cryptoRandomString from 'crypto-random-string'

export const DefaultOptions = {
  characters: 'abcabcdefghijklmnopqrstuvwxyzdefghABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789!"#$%&\\\'() *+,-./:;<=>?@[]^_`{|}~',
}

export default async function generateRandomString(length, options = {}) {
  const {characters} = {...DefaultOptions, ...options}
  return cryptoRandomString({length, characters})
}
